import { v1ApiPath } from '../../../lib/api';

const registrationsCreateApiPath = () => v1ApiPath('registrations');

export const getRegistrationsApiUrl = {
  create: () => registrationsCreateApiPath(),
};
